import en from "../locales/en.json";
import ft from "../locales/ft.json";

export default {
  en,
  ft,
};





// WEBPACK FOOTER //
// ./src/i18n/messages.js